export default __webpack_public_path__ + "static/media/rigit_side_arrow_svg.3993998b.svg";